export type AppEnvironment = 'dev' | 'staging' | 'production';

export function getAppEnvironment(): AppEnvironment {
  const envVar = import.meta.env.VITE_ENV;

  if (envVar === 'staging' || envVar === 'stg') {
    return 'staging';
  }

  if (envVar === 'production' || envVar === 'prod') {
    return 'production';
  }

  return 'dev';
}

export function isProductionEnvironment(): boolean {
  return getAppEnvironment() === 'production';
}

export function areInternalSettingsTabsEnabled(): boolean {
  return !isProductionEnvironment();
}
